import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Considerapp = () => {
  return (
    <div className="consider_usa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={5}>
            <div className="consider_content">
              <h2>When to Consider Our Unity Game Development Services</h2>
              <p>
                TekRevol understands that there are specific moments in your
                gaming endeavors when our Unity game development services can
                make a significant impact. Let's explore these scenarios to help
                you determine the perfect time to consider partnering with us.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Build Your Game App!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="consider-box">
              <h6>Launching Your First Game?</h6>
              <p>
                For first-time ventures into the gaming world, our Unity games
                development services are your perfect companion. We guide you
                through the entire process, from conceptualization to launch.
              </p>
            </div>
            <div className="consider-box">
              <h6>Updating an Existing Game?</h6>
              <p>
                Is your game in need of a refresh or additional features? Our
                services are ideal for enhancing existing games. Whether it's
                introducing new levels, improving graphics, or fixing bugs.
              </p>
            </div>
            <div className="consider-box">
              <h6>Facing Technical Challenges?</h6>
              <p>
                Facing Unity game challenges? Seek our expertise. We specialize
                in troubleshooting and optimizing, ensuring a seamless gaming
                experience by resolving performance issues and coding
                complexities.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Considerapp;
